import { DiscordSDK } from "@discord/embedded-app-sdk";

export default class Discord {
  constructor() {
    this.discordSdk = null;
    this.auth = null;
  }
  isOnDiscord() {
    //check url for discord
    const isOnDiscord = window.location.host.includes("discord");
    return isOnDiscord;
  }
  async getData(){
                    //get name and avatar
                    let auth = await this.setupDiscordSdk();
                    let guildMemeber = await this.getGuildMember(auth.access_token);
                    let name = this.getUserDisplayName(auth.user, guildMemeber);
                    console.log("Discord Name", name);
                    let avatar = this.getUserAvatarUrl(auth.user, guildMemeber);
                    console.log("Discord Avatar", avatar);
                    let data = {
                        name: name,
                        avatar: avatar,
                        guildId: this.discordSdk.guildId
                    }
                    return data;
  }
  async setupDiscordSdk() {
    this.discordSdk = new DiscordSDK(import.meta.env.VITE_DISCORD_CLIENT_ID);
    await this.discordSdk.ready();
    console.log("Discord SDK is ready");

    // Authorize with Discord Client
    const { code } = await this.discordSdk.commands.authorize({
      client_id: import.meta.env.VITE_DISCORD_CLIENT_ID,
      response_type: "code",
      state: "",
      prompt: "none",
      scope: [
        "identify",
        "applications.commands",
        "guilds",
        "guilds.members.read"
      ],
    });

    // Retrieve an access_token from your activity's server
    const response = await fetch("/.proxy/api/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        code,
      }),
    });
    const { access_token } = await response.json();

    // Authenticate with Discord client (using the access_token)
    this.auth = await this.discordSdk.commands.authenticate({
      access_token,
    });
    console.log("Authenticated with Discord Client", this.auth);
    if (this.auth == null) {
      throw new Error("Authenticate command failed");
    }
    return this.auth;
  }
  async getGuildMember(access_token, discordSdk) {
    if (!access_token) auth = this.auth.access_token;
    if (!discordSdk) discordSdk = this.discordSdk;
    // Get guild specific nickname and avatar, and fallback to user name and avatar
    const guildMember = await fetch(
      `https://discord.com/api/v10/users/@me/guilds/${discordSdk.guildId}/member`,
      {
        method: 'get',
        headers: { Authorization: `Bearer ${access_token}` },
      },
    )
      .then((j) => j.json())
      .catch(() => {
        return null;
      });
      return guildMember;
  }
  getUserDisplayName(user, guildMember) {
    if (guildMember?.nick != null && guildMember.nick !== '') return guildMember.nick;

    if (user.discriminator !== '0') return `${user.username}#${user.discriminator}`;

    if (user.global_name != null && user.global_name !== '') return user.global_name;

    return user.username;
  }

  getUserAvatarUrl(user, guildMember, discordSdk, cdn = `https://cdn.discordapp.com`, size = 256) {
    if (!user) user = this.auth.user;
    if (!discordSdk) discordSdk = this.discordSdk;

    if (guildMember?.avatar != null && discordSdk.guildId != null) {
      return `${cdn}/guilds/${discordSdk.guildId}/users/${user.id}/avatars/${guildMember.avatar}.png?size=${size}`;
    }
    if (user.avatar != null) {
      return `${cdn}/avatars/${user.id}/${user.avatar}.png?size=${size}`;
    }

    const defaultAvatarIndex = Math.abs(Number(user.id) >> 22) % 6;
    return `${cdn}/embed/avatars/${defaultAvatarIndex}.png?size=${size}`;
  }

  async appendGuildAvatar() {
    const app = document.querySelector('#app');

    // 1. From the HTTP API fetch a list of all of the user's guilds
    const guilds = await fetch(`https://discord.com/api/v10/users/@me/guilds`, {
      headers: {
        // NOTE: we're using the access_token provided by the "authenticate" command
        Authorization: `Bearer ${this.auth.access_token}`,
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());

    // 2. Find the current guild's info, including it's "icon"
    const currentGuild = guilds.find((g) => g.id === this.discordSdk.guildId);

    // 3. Append to the UI an img tag with the related information
    if (currentGuild != null) {
      return `https://cdn.discordapp.com/icons/${currentGuild.id}/${currentGuild.icon}.webp?size=128`;
    }
    else {
      return null;
    }
  }


}